module.exports = __webpack_public_path__ + "static/media/susan3.02b5a93b.mp3";